import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const API = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/login', { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for session data
        const response = await axios.post(
          `${API}/api/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const user = response.data;

        // Redirect to main app with user data
        navigate('/', { replace: true, state: { user } });

      } catch (error) {
        console.error('Auth callback error:', error);
        
        // Handle specific error messages
        const errorMessage = error.response?.data?.detail || 'Authentication failed';
        
        if (errorMessage.includes('wellversed.in')) {
          navigate('/login', { 
            replace: true, 
            state: { error: 'Access restricted to @wellversed.in accounts only' }
          });
        } else {
          navigate('/login', { 
            replace: true, 
            state: { error: errorMessage }
          });
        }
      }
    };

    processAuth();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-6 relative">
          <div className="absolute inset-0 rounded-full border-2 border-[#00f0ff]/30 animate-ping" />
          <div className="absolute inset-2 rounded-full border-2 border-[#00f0ff]/50 animate-spin" style={{ borderTopColor: 'transparent' }} />
          <div className="absolute inset-4 rounded-full bg-[#00f0ff]/20 flex items-center justify-center">
            <span className="text-[#00f0ff] text-lg font-bold">O</span>
          </div>
        </div>
        <p className="text-[#00f0ff]/60 font-mono text-sm animate-pulse">
          Authenticating...
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
